import styled from '@emotion/styled';

import { withConfig } from 'src/withConfig';



export const GoalScorerMarketListWrapper = styled('div', { label: 'GoalScorerMarketListWrapper' })`

    display: flex;

    flex-flow: column nowrap;

    flex: 1 1 100%;

    &:empty {

        display: none;

    }

`;



export const GoalScorerMarketListItem = withConfig(theme => styled('div', { label: 'GoalScorerMarketListItem' })<{columns: number}>`

    gap: ${theme.star.gap.medium};

    padding: ${theme.star.padding.medium};

    border-bottom: 1px solid ${theme.star.unified.selection.borderColor};

    display: grid;

    ${({ columns }) => `grid-template-columns:  repeat(${columns}, minmax(0, 1fr));`}



    .no-selection {

        display: none;

    }

`);



export const MarketGroupCaption = withConfig(theme => styled('div', { label: 'MarketGroupCaption' })`

    font-size: ${theme.star.fontSize.small};

    color: ${theme.star.unified.eventHeaderCaption.txtColorSecondary};

    padding: ${theme.star.padding.medium} ${theme.star.padding.xMedium};

    background: ${theme.star.unified.eventHeaderCaption.bgColor};

    align-items: center;

    display: flex;

    justify-content: space-between;

    line-height: 1.4;

    position: relative;

`);





export const Caption = styled('span', { label: 'Caption' })`

    padding: 0;

    border: none;

    text-align: center;

    flex: 1 1 25%;

`;



interface GoalscorerNamePropsType {

    templateId?: string;

}



export const GoalscorerName = withConfig(theme => styled('div', { label: 'GoalscorerName' })<GoalscorerNamePropsType>`

    background: ${({ templateId }): string => templateId === 'NG' ? theme.star.marketGroupGoalscorer.bgColorTertiary : 'transparent'};

    color: ${theme.star.selectionsGroup.txtColor};

    line-height: 1.3334;

    flex: 1 1 25%;

    align-items: center;

    

    display: flex;

    font-size: ${theme.star.unified.eventRow.typography.fontSizePrimary};

    font-weight: ${theme.star.unified.eventRow.typography.fontWeightSecondary};



    span {

        min-width: 100px;

        max-width: 100px;

        overflow: hidden;

        text-overflow: ellipsis;

        white-space: nowrap;

    }



    @media ${theme.star.mediaQuery.tablet} {

        justify-content: center;

        

        span {

            max-width: 100%;

            text-align: center;

        }

    }

`);

